export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000',
    timeout: 30000,
  },
  app: {
    name: '999 Viagens - Backoffice',
    version: '1.0.0',
  },
};